export const EVENT_OPEN_CITY_MODAL = 'open-city-modal';
export const EVENT_CITY_CHANGED = 'city-changed';

export const utilEventCityModal = {
  open: () => {
    window.dispatchEvent(new CustomEvent(EVENT_OPEN_CITY_MODAL));
  },
  onOpen: (callback: () => void) => {
    const handler = () => callback();
    window.addEventListener(EVENT_OPEN_CITY_MODAL, handler);

    return () => {
      window.removeEventListener(EVENT_OPEN_CITY_MODAL, handler);
    };
  }
};
